import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from "@angular/core";
import { NgxSmartModalService } from "ngx-smart-modal";
import { UI } from "../../services/ui.service";
import { ShowRepository } from "../../domain/show-repository";

@Component({
  selector: "icn-rename-show-modal",
  templateUrl: "./rename-show-modal.component.html",
  styleUrls: ["./rename-show-modal.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RenameShowModalComponent implements AfterViewInit {
  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    private changeDetectorRef: ChangeDetectorRef,
    private showRepository: ShowRepository,
    private ui: UI,
  ) {}

  showId: string;
  oldName: string;
  name: string;

  ngAfterViewInit() {
    this.ngxSmartModalService
      .getModal("renameShowModal")
      .onDataAdded.subscribe((data: { showId: string; oldName: string }) => {
        this.showId = data.showId;
        this.oldName = data.oldName;
        this.name = this.oldName;
        this.changeDetectorRef.markForCheck();
      });
  }

  canRename() {
    return !!this.name && this.name != this.oldName;
  }

  cancel() {
    this.ngxSmartModalService.getModal("renameShowModal").close();
  }

  rename() {
    if (!this.canRename()) {
      return;
    }

    this.showRepository
      .renameShow(this.showId, this.name)
      .then(() => {
        this.ngxSmartModalService.getModal("renameShowModal").close();
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Success",
          message: "Success",
        });
      })
      .catch((error) => {
        this.ngxSmartModalService.getModal("renameShowModal").close();
        this.ui.notify(this.ui.EVENTS.ShowAlert, {
          title: "Couldn't complete the operation",
          message: "An error has occurred",
        });
      });
  }

  // replace() {
  //     if (!this.mediaCustomId || (this.applyToAllInstances && !this.untilDate)) {
  //         return;
  //     }
  //
  //     this.broadcastItemApi.replaceShow(this.showId, this.mediaCustomId, this.applyToAllInstances, this.untilDate)
  //         .then(() => {
  //             this.broadcastItemsCache.refreshCache();
  //         }).then(() => {
  //         this.ngxSmartModalService.getModal('replaceShowModal').close();
  //         this.ui.notify(this.ui.EVENTS.ShowAlert, {
  //             title: "Success",
  //             message: "Successfully replaced show"
  //         });
  //     }).catch(error => {
  //         this.ngxSmartModalService.getModal('replaceShowModal').close();
  //         let errorMessage;
  //         if (error.status === 404) {
  //             errorMessage = 'Media id doesn\'t exist';
  //         } else if (error.status === 400) {
  //             errorMessage = JSON.parse(error._body).Message;
  //         }
  //         else {
  //             errorMessage = 'An error has occurred';
  //         }
  //
  //         this.ui.notify(this.ui.EVENTS.ShowAlert, {
  //             title: "Couldn't complete the operation",
  //             message: errorMessage
  //         });
  //     });
  //}
}
